Service = App.loadClass 'core::Angular/Service'

class exports.BushelsService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getBushelsByYear: (bushelsIncrease) =>
        # When the function is called by the Angular controller, hit the following route
        # (which will trigger a function in the Bushels.php controller)
        @http.post 'backend/admin/new-tools/bushels/get-bushels-by-year',
            # pass the bushelsIncrease value to a newly-created variable "bushelsIncrease" (left side)
            bushelsIncrease: bushelsIncrease
